import { InformationFileViewModel } from "./InformationFileViewModel";
import { InformationResponseViewModel } from "./InformationResponseViewModel";
import Enumerable from "linq";
export class InformationViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.informationNo = data.informationNo;
        this.weight = data.weight;
        this.target = data.target;
        this.isResponseRequired = data.isResponseRequired;
        this.startAt = data.startAt;
        this.responseDeadline = data.responseDeadline;
        this.subject = data.subject;
        this.main = data.main;
        this.affirmativeText = data.affirmativeText;
        this.negativeText = data.negativeText;
        this.responseDeadline = data.responseDeadline;
        this.response = Enumerable.from(data.responses).select(x => new InformationResponseViewModel(x)).toArray();
        this.files = Enumerable.from(data.files).select(x => new InformationFileViewModel(x)).toArray();
    }
    model = null;
    informationNo = null;
    startAt = "";
    endAt = "";
    weight = false;
    target = null;
    subject = "";
    main = "";
    isResponseRequired = false;
    affirmativeText = "";
    negativeText = "";
    responseDeadline = "";
    response = [];
    files = [];
    get firstResponse() {
        return Enumerable.from(this.response).firstOrDefault() ?? new InformationResponseViewModel();
    }
}
